/**
 * TanStack Router: /orgchart
 *
 * This route file was auto-generated by the route generation script.
 * Component: OrgChartPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import OrgChartPage from '@/app/orgchart/page'

/**
 * Route: /orgchart
 * Layout: _auth (authenticated)
 * Component: OrgChartPage
 */
export const Route = createFileRoute('/_auth/orgchart')({
  component: OrgChartPage,
})
